import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding-top: 80px; /* Account for fixed header */
`;

const HeroSection = styled.section`
  background-color: var(--black);
  color: var(--white);
  padding: 6rem 0;
  text-align: center;
`;

const HeroContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const PageTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 1.5rem;
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const PageDescription = styled.p`
  font-size: 1.2rem;
  color: var(--gray-300);
  margin-bottom: 2rem;
  line-height: 1.6;
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ContactCard = styled.div`
  background: var(--white);
  border-radius: 16px;
  box-shadow: 0 6px 32px rgba(0,0,0,0.07);
  max-width: 500px;
  margin: 0 auto 5rem auto;
  padding: 3rem 2rem 2rem 2rem;
  text-align: left;
  position: relative;
  top: -60px;
  z-index: 2;
`;

const ContactCardTitle = styled.h2`
  font-size: 2rem;
  color: var(--black);
  margin-bottom: 1.2rem;
`;

const ContactHighlight = styled.span`
  color: #30e8be;
  font-weight: 600;
`;


const ContactDetails = styled.div`
  margin-bottom: 2rem;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
`;

const ContactIcon = styled.div`
  width: 40px;
  height: 40px;
  background-color: var(--primary-light);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  color: var(--primary);
  font-size: 1.2rem;
`;

const ContactItemContent = styled.div``;

const ContactItemTitle = styled.h4`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
`;

const ContactItemText = styled.p`
  color: var(--gray-700);
`;

const ContactPage = () => (
    <PageContainer>
      <HeroSection>
        <HeroContent>
          <PageTitle>Contact Us</PageTitle>
          <PageDescription>
            Have a question or want to work with us? Reach out and our team will get back to you as soon as possible.
          </PageDescription>
        </HeroContent>
      </HeroSection>
      <ContactCard>
        <ContactCardTitle>Get in Touch</ContactCardTitle>
        <ContactDetails>
          <ContactItem>
            <ContactIcon>✉️</ContactIcon>
            <ContactItemContent>
              <ContactItemTitle>Email</ContactItemTitle>
              <ContactItemText><ContactHighlight>hello@platform0.ca</ContactHighlight></ContactItemText>
            </ContactItemContent>
          </ContactItem>
          <ContactItem>
            <ContactIcon>⏰</ContactIcon>
            <ContactItemContent>
              <ContactItemTitle>Working Hours</ContactItemTitle>
              <ContactItemText>Monday - Friday: <ContactHighlight>9am - 6pm PST</ContactHighlight></ContactItemText>
            </ContactItemContent>
          </ContactItem>
        </ContactDetails>
      </ContactCard>
    </PageContainer>
);

export default ContactPage;
